export const MainHeader = "atlantis-main-header";
